/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavMissionTrackAction
 */
export interface OutputUavMissionTrackAction {
    /**
     * Action — status_change | position_drag | place_report | flight_params | shootdown_add | ...
     * (models.UavAction*).
     * @type {string}
     * @memberof OutputUavMissionTrackAction
     */
    action?: string;
    /**
     * Approximate — дії в журналі немає (заявка старша за журнал), зміну фази відновлено з
     * журналу фаз, а позицію поставлено на штатне місце фази за поточною лінією фронту.
     * @type {boolean}
     * @memberof OutputUavMissionTrackAction
     */
    approximate?: boolean;
    /**
     * AuthorName — позивний користувача Levitation (UI) або Matrix-логін (Element); порожньо — система.
     * @type {string}
     * @memberof OutputUavMissionTrackAction
     */
    authorName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavMissionTrackAction
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionTrackAction
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavMissionTrackAction
     */
    lng?: number;
    /**
     * Payload — дані дії: {"from","to"} для фази, {"altitude":{"from","to"}}, {"place"}, ...
     * @type {{ [key: string]: object; }}
     * @memberof OutputUavMissionTrackAction
     */
    payload?: { [key: string]: object; };
    /**
     * Source — ui | element | system.
     * @type {string}
     * @memberof OutputUavMissionTrackAction
     */
    source?: string;
    /**
     * Status — фаза заявки в момент дії (для status_change — нова фаза).
     * @type {string}
     * @memberof OutputUavMissionTrackAction
     */
    status?: string;
}

/**
 * Check if a given object implements the OutputUavMissionTrackAction interface.
 */
export function instanceOfOutputUavMissionTrackAction(value: object): boolean {
    return true;
}

export function OutputUavMissionTrackActionFromJSON(json: any): OutputUavMissionTrackAction {
    return OutputUavMissionTrackActionFromJSONTyped(json, false);
}

export function OutputUavMissionTrackActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavMissionTrackAction {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'] == null ? undefined : json['action'],
        'approximate': json['approximate'] == null ? undefined : json['approximate'],
        'authorName': json['authorName'] == null ? undefined : json['authorName'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'payload': json['payload'] == null ? undefined : json['payload'],
        'source': json['source'] == null ? undefined : json['source'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function OutputUavMissionTrackActionToJSON(value?: OutputUavMissionTrackAction | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'action': value['action'],
        'approximate': value['approximate'],
        'authorName': value['authorName'],
        'createdAt': value['createdAt'],
        'lat': value['lat'],
        'lng': value['lng'],
        'payload': value['payload'],
        'source': value['source'],
        'status': value['status'],
    };
}

